export default __webpack_public_path__ + "static/media/provider-streak-group.3cbd4e75.svg";